/* Entrada da aplicação: login (e-mail e senha ou demonstração), casca do app e roteador. */

import './estilos/index.css';
import { EVENTO_SESSAO_EXPIRADA } from './core/api';
import { aoCarregarCatalogo, esquecerCatalogo } from './core/catalogo';
import { CFG, salvarCfg } from './core/config';
import { state } from './core/estado';
import { aplicarTema, entrarComSenha, limparSessao, sair, sessaoValida } from './core/sessao';
import { abrirApp, fecharApp, iniciarRoteador, ir, render } from './roteador';
import { $ } from './ui/dom';
import { renderEnv, renderQuem, renderRail, secao, secaoVisivel } from './ui/shell';
import { toast } from './ui/toast';

function mostrarApp(): void {
  aplicarTema();
  state.f.obra = '';
  esquecerCatalogo();
  renderEnv();
  renderQuem();
  $('#loginView').style.display = 'none';
  $('#app').classList.add('on');
  abrirApp();
}

function mostrarLogin(mensagem = ''): void {
  delete document.documentElement.dataset.theme; // a tela de login é sempre clara
  fecharApp();
  $('#app').classList.remove('on');
  $('#loginView').style.display = 'grid';
  const erro = $('#loginErro');
  erro.textContent = mensagem;
  erro.hidden = !mensagem;
  location.hash = '';
  $('#loginEmail').focus();
}

async function entrar(ev: SubmitEvent): Promise<void> {
  ev.preventDefault();
  const botao = $('#btnEntrar');
  botao.classList.add('dis');
  try {
    await entrarComSenha($<HTMLInputElement>('#loginEmail').value.trim(), $<HTMLInputElement>('#loginSenha').value);
    $<HTMLFormElement>('#loginForm').reset();
    mostrarApp();
    toast(`Bem-vindo${CFG.usuario?.nome ? `, ${CFG.usuario.nome.split(' ')[0]}` : ''}.`);
  } catch (e) {
    mostrarLogin((e as Error).message || 'Não foi possível entrar.');
  } finally {
    botao.classList.remove('dis');
  }
}

function entrarDemo(): void {
  limparSessao();
  CFG.modo = 'demo';
  salvarCfg();
  mostrarApp();
  toast('Demonstração com dados simulados.');
}

async function sairDoApp(): Promise<void> {
  await sair();
  mostrarLogin();
}

/** Troca de empresa no topo: recarrega o catálogo (obras) e a tela atual com o novo CNPJ. */
function trocarEmpresa(ev: Event): void {
  CFG.cnpj = (ev.target as HTMLSelectElement).value;
  salvarCfg();
  state.f.obra = '';
  esquecerCatalogo();
  render();
}

aoCarregarCatalogo(() => {
  renderQuem();
  renderRail(); // Emissões só aparece para quem pode lançar no CNPJ escolhido
  const atual = secao(state.sec);
  if (atual && !secaoVisivel(atual)) ir('#/painel');
});
$('#empresaSelect').addEventListener('change', trocarEmpresa);
iniciarRoteador();
$<HTMLFormElement>('#loginForm').addEventListener('submit', (ev) => void entrar(ev));
$('#btnDemo').addEventListener('click', entrarDemo);
$('#btnSair').addEventListener('click', () => void sairDoApp());
$('#envPill').addEventListener('click', () => ir('#/config'));
window.addEventListener(EVENTO_SESSAO_EXPIRADA, () => {
  limparSessao();
  mostrarLogin('Sua sessão expirou. Entre novamente.');
});
renderEnv();

// Sessão salva e ainda válida: abre direto, sem pedir a senha de novo.
if (CFG.modo === 'api' && CFG.token) {
  void sessaoValida().then((ok) => (ok ? mostrarApp() : mostrarLogin()));
} else {
  mostrarLogin();
}
